import React from 'react';
import ProjectCard from './ProjectCard.jsx';
import ProjectGridstyle from '../css/ProjectGrid.css'

function ProjectGrid({ projects }) {
  return (
    <div className="project-grid">

      {projects.map((project) => (
        <ProjectCard
            key={project.ID}
            project={project}
        />
    ))}

    </div>
  );
}

export default ProjectGrid;